import { useQuery } from "@tanstack/react-query"

import { FINANCE_DOCUMENTS_QUERY_KEY } from "@/constants/query"


const MOCK_DATA = [
  {
    id: 1,
    name: "СчетаНаОплату"
  },
  {
    id: 2,
    name: "Торг12"
  },
  {
    id: 3,
    name: "Доверенность"
  },
  {
    id: 4,
    name: "СчетФактуры"
  },
  {
    id: 5,
    name: "СчетФактурыАванс"
  },
  {
    id: 6,
    name: "АктыСверки"
  }
]

export const useFinanceDocumentTypeQuery = () => {
  return useQuery({
    queryFn: () => MOCK_DATA,
    queryKey: [FINANCE_DOCUMENTS_QUERY_KEY]
  })
}